"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicationKnowledge_Regulatory = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_MedicationKnowledge_Substitution_1 = require("./RTTI_MedicationKnowledge_Substitution");
var RTTI_MedicationKnowledge_Schedule_1 = require("./RTTI_MedicationKnowledge_Schedule");
var RTTI_MedicationKnowledge_MaxDispense_1 = require("./RTTI_MedicationKnowledge_MaxDispense");
exports.RTTI_MedicationKnowledge_Regulatory = t.recursion('IMedicationKnowledge_Regulatory', function () {
    return t.intersection([
        t.type({
            regulatoryAuthority: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            substitution: t.array(RTTI_MedicationKnowledge_Substitution_1.RTTI_MedicationKnowledge_Substitution),
            schedule: t.array(RTTI_MedicationKnowledge_Schedule_1.RTTI_MedicationKnowledge_Schedule),
            maxDispense: RTTI_MedicationKnowledge_MaxDispense_1.RTTI_MedicationKnowledge_MaxDispense
        })
    ]);
});
//# sourceMappingURL=RTTI_MedicationKnowledge_Regulatory.js.map